const highlights = {
  backgroundPosition: 'bottom 9px right -20px',
  backgroundRepeat: 'no-repeat',
  backgroundSize: '100% 30%',
  display: 'inline',
  fontStretch: 'normal',
  lineHeight: 'normal',
  padding: '10px',
  wordBreak: 'break-word',
};

const variants = {
  resetSpacing: {
    margin: '0px',
    padding: '0px',
  },

  backgroundImage: {
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    width: '100%',
  },
  button: {
    variant: 'resetSpacing',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
  },
  container: {
    frontpage: {
      display: 'grid',
      gridGap: 16,
      gridTemplateColumns: 'minmax(auto, 1140px)',
      justifyContent: 'center',
      paddingBottom: 16,
      paddingTop: 20,
      paddingX: 7,

      '@media screen and (min-width: 768px)': {
        gridGap: 20,
        paddingBottom: 16,
        paddingTop: 20,
        paddingX: 8,
        padding: '100px 25px 65px 25px',
      },

      '@media screen and (min-width: 1400px)': {
        gridGap: 21,
        paddingX: 8,
        paddingY: 22,
      },
    },
    page: {
      display: 'grid',
      gridGap: 8,
      gridTemplateColumns: 'minmax(auto, 1140px)',
      justifyContent: 'center',
      paddingBottom: 16,
      paddingTop: 21,
      paddingX: 7,
      position: 'relative',

      '@media screen and (min-width: 768px)': {
        gridGap: 12,
        paddingBottom: 16,
        paddingTop: 20,
        paddingX: 8,
      },

      '@media screen and (min-width: 1400px)': {
        columnGap: 12,
        rowGap: 17,
        paddingX: 8,
        paddingY: 22,
      },
    },
  },
  content: {
    display: 'grid',
    gridGap: 8,
    gridTemplateColumns: '1fr',
    justifyContent: 'start',

    '@media screen and (min-width: 768px)': {
      gridGap: 12,
    },

    '@media screen and (min-width: 1400px)': {
      columnGap: 12,
      rowGap: 17,
    },
  },
  heading: {
    variant: 'resetSpacing',
    boxSizing: 'border-box',
    color: 'black',
    fontFamily: 'heading',
    fontWeight: 'black',
  },
  headings: {
    one: {
      variant: 'heading',
      fontSize: 10,
      fontWeight: 'bold',
      letterSpacing: '1.2px',
      lineHeight: '1.2',

      '@media screen and (min-width: 600px)': {
        fontSize: 12,
        letterSpacing: '2.4px',
      },

      '@media screen and (min-width: 768px)': {
        fontSize: 13,
        letterSpacing: '2.9px',
      },
    },
    two: {
      variant: 'heading',
      fontSize: 6,
      fontWeight: 'black',
      letterSpacing: '1px',

      '@media screen and (min-width: 768px)': {
        fontSize: 9,
      },
    },
    three: {
      variant: 'heading',
      fontSize: 7,
      letterSpacing: '1.3px',
    },
    four: {
      variant: 'heading',
      fontSize: 2,
      letterSpacing: '0.6px',

      '@media screen and (min-width: 768px)': {
        fontSize: 4,
      },
    },
  },
  h1: {
    dark: {
      regular: {
        variant: 'headings.one',
      },
      highlight: {
        dark: {
          variant: 'headings.one',
          backgroundImage: theme =>
            `linear-gradient(${theme.colors.highlight.dark}, ${theme.colors.highlight.dark})`,
          ...highlights,
        },
        light: {
          variant: 'headings.one',
          backgroundImage: theme =>
            `linear-gradient(${theme.colors.highlight.light}, ${theme.colors.highlight.light})`,
          ...highlights,
        },
      },
    },
    light: {
      regular: {
        variant: 'headings.one',
        color: 'white',
      },
      highlight: {
        dark: {
          variant: 'headings.one',
          color: 'white',
          backgroundImage: theme =>
            `linear-gradient(${theme.colors.highlight.dark}, ${theme.colors.highlight.dark})`,
          ...highlights,
        },
        light: {
          variant: 'headings.one',
          color: 'white',
          backgroundImage: theme =>
            `linear-gradient(${theme.colors.highlight.light}, ${theme.colors.highlight.light})`,
          ...highlights,
        },
      },
    },
  },
  h2: {
    dark: {
      regular: {
        variant: 'headings.two',
      },
      highlight: {
        dark: {
          variant: 'headings.two',
          backgroundImage: theme =>
            `linear-gradient(${theme.colors.highlight.dark}, ${theme.colors.highlight.dark})`,
          ...highlights,
        },
        light: {
          variant: 'headings.two',
          backgroundImage: theme =>
            `linear-gradient(${theme.colors.highlight.light}, ${theme.colors.highlight.light})`,
          ...highlights,
        },
      },
    },
    light: {
      regular: {
        variant: 'headings.two',
        color: 'white',
      },
      highlight: {
        dark: {
          variant: 'headings.two',
          color: 'white',
          backgroundImage: theme =>
            `linear-gradient(${theme.colors.highlight.dark}, ${theme.colors.highlight.dark})`,
          ...highlights,
        },
        light: {
          variant: 'headings.two',
          color: 'white',
          backgroundImage: theme =>
            `linear-gradient(${theme.colors.highlight.light}, ${theme.colors.highlight.light})`,
          ...highlights,
        },
      },
    },
  },
  h3: {
    dark: {
      regular: {
        variant: 'headings.three',
      },
      highlight: {
        dark: {
          variant: 'headings.three',
          backgroundImage: theme =>
            `linear-gradient(${theme.colors.highlight.dark}, ${theme.colors.highlight.dark})`,
          ...highlights,
        },
        light: {
          variant: 'headings.three',
          backgroundImage: theme =>
            `linear-gradient(${theme.colors.highlight.light}, ${theme.colors.highlight.light})`,
          ...highlights,
        },
      },
    },
    light: {
      regular: {
        variant: 'headings.three',
        color: 'white',
      },
      highlight: {
        dark: {
          variant: 'headings.three',
          color: 'white',
          backgroundImage: theme =>
            `linear-gradient(${theme.colors.highlight.dark}, ${theme.colors.highlight.dark})`,
          ...highlights,
        },
        light: {
          variant: 'headings.three',
          color: 'white',
          backgroundImage: theme =>
            `linear-gradient(${theme.colors.highlight.light}, ${theme.colors.highlight.light})`,
          ...highlights,
        },
      },
    },
  },
  h4: {
    dark: {
      regular: {
        variant: 'headings.four',
      },
      highlight: {
        dark: {
          variant: 'headings.four',
          backgroundImage: theme =>
            `linear-gradient(${theme.colors.highlight.dark}, ${theme.colors.highlight.dark})`,
          ...highlights,
        },
        light: {
          variant: 'headings.four',
          backgroundImage: theme =>
            `linear-gradient(${theme.colors.highlight.light}, ${theme.colors.highlight.light})`,
          ...highlights,
        },
      },
    },
    light: {
      regular: {
        variant: 'headings.four',
        color: 'white',
      },
      highlight: {
        dark: {
          variant: 'headings.four',
          color: 'white',
          backgroundImage: theme =>
            `linear-gradient(${theme.colors.highlight.dark}, ${theme.colors.highlight.dark})`,
          ...highlights,
        },
        light: {
          variant: 'headings.four',
          color: 'white',
          backgroundImage: theme =>
            `linear-gradient(${theme.colors.highlight.light}, ${theme.colors.highlight.light})`,
          ...highlights,
        },
      },
    },
  },
  highlights: highlights,
  highlight: {
    dark: {
      backgroundImage: theme =>
        `linear-gradient(${theme.colors.highlight.dark}, ${theme.colors.highlight.dark})`,
    },
    light: {
      backgroundImage: theme =>
        `linear-gradient(${theme.colors.highlight.light}, ${theme.colors.highlight.light})`,
    },
  },
  icon: {
    transform: 'translateX(0px) scale(0.7)',
    transition: 'transform 600ms ease-in-out',

    '@media screen and (min-width: 1140px)': {
      transform: 'unset',
    },

    '@media screen and (max-height: 700px)': {
      transform: 'scale(0.7)',
    },
  },
  iconWrapper: {
    alignItems: 'center',
    border: '2px solid',
    borderColor: 'black',
    borderRadius: '50%',
    color: 'black',
    display: 'flex',
    height: '36px',
    justifyContent: 'center',
    padding: 1,
    position: 'absolute',
    width: '36px',

    '::after': {
      backgroundColor: 'highlight.light',
      borderRadius: '50%',
      content: '""',
      display: 'block',
      height: 'inherit',
      position: 'absolute',
      transform: 'translate(5px, 5px)',
      transition: 'transform 0.2s ease-in-out',
      width: 'inherit',
      zIndex: '-1',
    },

    '@media screen and (min-width: 1140px)': {
      ':hover': {
        '::after': {
          transform: 'translate(0px, 0px)',
        },
      },
    },
  },
  image: {
    height: '100%',
    maxHeight: '100%',
    maxWidth: '100%',
    objectFit: 'cover',
    width: '100%',
  },
  link: {
    cursor: 'pointer',
    display: 'inline-block',
    fontFamily: 'body',
    outline: 'none',
    textDecoration: 'none',
  },
  paragraph: {
    color: 'grey',
    fontFamily: 'body',
    fontSize: 3,
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 'light',
    letterSpacing: '0.5px',
    lineHeight: '1.38',
    margin: 0,
    maxWidth: '750px',
  },
  section: {
    display: 'grid',
    gridGap: 11,
    position: 'relative',

    '&.divider': {
      paddingBottom: 13,

      '::after': {
        backgroundColor: 'black',
        bottom: '0px',
        content: '""',
        height: '2px',
        left: '0px',
        maxWidth: '1100px',
        position: 'absolute',
        width: '80vw',
      },
    },
  },
};

export default variants
